module.exports = __webpack_public_path__ + "img/fitt_light_old.a06277d2.png";